import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetActiveRound = createAsyncThunk(
  "ActiveRound/GetActiveRound",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ApplicationInformationModel/GetActiveRound",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data,"app");
      return data; // Return the extracted data
      
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



const RoundReducers = createSlice({
  name: "RoundReducers",
  initialState: {

    ActiveRound: {},
    loadingActiveRound: false,
    errorActiveRound: null,

  },
  reducers: {},
  extraReducers: (builder) => {

      builder
      .addCase(GetActiveRound.pending, (state, action) => {
        state.loadingActiveRound = true;
        state.ActiveRound = action.payload;
        state.errorActiveRound = null;
      })
      .addCase(GetActiveRound.fulfilled, (state, action) => {
        state.loadingActiveRound = false;
        state.ActiveRound = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetActiveRound.rejected, (state, action) => {
        state.loadingActiveRound = false;
        state.errorActiveRound = action.payload;
      });

  },
});

export default RoundReducers.reducer;
